import { useContext } from 'react';
import { UsersContext, UsersContextValue } from './UsersContext';

export default function useUsers(): UsersContextValue {
  const value = useContext(UsersContext);

  if (!value) {
    throw new Error(
      "useUsers: used outside the Users feature root. Only the feature's own components and hooks may call it — anything a host mounts on its own takes viewer/account/permissions as props instead.",
    );
  }

  return value;
}
